module.exports = __webpack_public_path__ + "img/clapping_hands.e12841dc.gif";